import types from "./actionTypes";
import api from "../api/candidate.resource";
import { ROLES } from "../constants/constants";

export const candidateActions = {
  getCandidateDetails: candidateId => async dispatch => {
    try {
      const res = await api.getCandidateDetails(candidateId);
      dispatch({ type: types.GET_CANDIDATE_DETAILS, res });
    } catch (e) {
      console.log(e);
    }
  },
  resetCandidateDetails: () => {
    return {
      type: types.RESET_CANDIDATE_DETAILS
    };
  },

  setCandidatePersonalDetails: (fieldName, fieldValue) => {
    return {
      type: types.SET_CANDIDATE_PERSONAL_DETAILS,
      fieldName,
      fieldValue
    };
  },

  updateCandidateQualificationDetails: (id, fieldName, fieldValue) => {
    return {
      type: types.UPDATE_CANDIDATE_QUALIFICATION_DETAILS,
      id,
      fieldName,
      fieldValue
    };
  },
  addCandidateQualificationDetails: newQualification => {
    return {
      type: types.ADD_CANDIDATE_QUALIFICATION_DETAILS,
      newQualification
    };
  },
  deleteCandidateQualificationDetails: id => {
    return {
      type: types.DELETE_CANDIDATE_QUALIFICATION_DETAILS,
      id
    };
  },

  addCandidateAddressDetails: newAddress => {
    return {
      type: types.ADD_CANDIDATE_ADDRESS_DETAILS,
      newAddress
    };
  },
  updateCandidateAddressDetails: (id, fieldName, fieldValue) => {
    return {
      type: types.UPDATE_CANDIDATE_ADDRESS_DETAILS,
      id,
      fieldName,
      fieldValue
    };
  },
  updateCandidateAddressDetailsBulk: (id, addressDetails) => {
    return {
      type: types.UPDATE_CANDIDATE_ADDRESS_DETAILS_ALL,
      id,
      addressDetails
    };
  },
  updateCandidateOrganizationDetails: (id, fieldName, fieldValue) => {
    return {
      type: types.UPDATE_CANDIDATE_ORGANIZATON_DETAILS,
      id,
      fieldName,
      fieldValue
    };
  },
  addCandidateOrganizationDetails: newOrganization => {
    return {
      type: types.ADD_CANDIDATE_ORGANIZATON_DETAILS,
      newOrganization
    };
  },
  deleteCandidateOrganizationDetails: id => {
    return {
      type: types.DELETE_CANDIDATE_ORGANIZATON_DETAILS,
      id
    };
  },

  getCandidatesList: () => async dispatch => {
    try {
      const res = await api.getCandidatesList();
      dispatch({ type: types.GET_CANDIDATES_LIST, res });
    } catch (e) {
      console.log(e);
    }
  },
  updateCandidatesList: (id, fieldName, fieldValue) => {
    return {
      type: types.UPDATE_CANDIDATES_LIST,
      id,
      fieldName,
      fieldValue
    };
  },
  getRecruitersList: () => async dispatch => {
    try {
      const res = await api.getUsersList();
      dispatch({ type: types.GET_RECRUITERS_LIST, res });
    } catch (e) {
      console.log(e);
    }
  },
  getGendersList: () => async dispatch => {
    try {
      const res = await api.getGendersList();
      dispatch({ type: types.GET_GENDERS_LIST, res });
    } catch (e) {
      console.log(e);
    }
  },
  getUserRoles: () => async dispatch => {
    try {
      const res = await api.getUserRoles();
      dispatch({ type: types.GET_USER_ROLES, res });
    } catch (e) {
      console.log(e);
    }
  },
  getMaritalStatusList: () => async dispatch => {
    try {
      const res = await api.getMaritalStatusList();
      dispatch({ type: types.GET_MARITAL_STATUS_LIST, res });
    } catch (e) {
      console.log(e);
    }
  },
  getStatesList: () => async dispatch => {
    try {
      const res = await api.getStatesList();
      dispatch({ type: types.GET_STATES_LIST, res });
    } catch (e) {
      console.log(e);
    }
  }
};
